{
  "label": "Aviseringar",
  "arrear": "Försenade betalningar",
  "contract_termination_request_approval_needed": {
    "title": "Avslutat avtal",
    "content": "Godkänn eller avvisa ändringen",
    "rightOfOccupancyNoticeTitle": "Överlåtelseanmälan gjord"
  },
  "contract_termination_request_tenant_rejected": "Uppsägningen har avbrutits eftersom en annan part inte godkände den.",
  "contract_termination_request_kenno_rejected": "Uppsägningen har avvisats. Du kommer att få mer information via e-post.",
  "message": "Du har ett nytt meddelande",
  "viewMessages": "Visa meddelanden",
  "contract_modification_request_approval_needed": {
    "title": "Hyresgäst har sagt upp",
    "content": "Godkänn eller avvisa ändringen"
  }
}
